import React, { useState, useEffect, useContext } from "react"; // Importă useState și useEffect
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore"; // Importă query și where
import app from "../../firebaseConfig"; // Importă aplicația Firebase
import { getApp } from "firebase/app";
import Box from "@mui/material/Box"; // Import Box from MUI
import { useNavigate } from "react-router-dom"; // Importă useNavigate pentru navigare
import "./ProductsCardContainer.css"; // Asigură-te că ai acest fișier CSS pentru stilizare
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { useCart } from "../../context/CartContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const db = getFirestore(getApp()); // Obține instanța Firestore din Firebase App

const ProductsCardContainer = ({ category }) => {
  const [products, setProducts] = useState([]); // State pentru produse
  const [loading, setLoading] = useState(true); // State pentru a gestiona încărcarea datelor
  const { updateCartCount } = useCart();
  const [cart, setCart] = useState(
    Array.isArray(JSON.parse(sessionStorage.getItem("cart")))
      ? JSON.parse(sessionStorage.getItem("cart"))
      : []
  );
  const navigate = useNavigate(); // Hook pentru navigare

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        let productsQuery = collection(db, "Products");

        if (category) {
          // Convertește categoria din URL la litere mari pentru a o compara cu valorile din Firestore
          const normalizedCategory =
            category.charAt(0).toUpperCase() + category.slice(1); // Exemplu: 'topuri' devine 'Topuri'
          productsQuery = query(
            productsQuery,
            where("category", "==", normalizedCategory)
          );
        }

        const querySnapshot = await getDocs(productsQuery);
        const productsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(productsList); // Salvează produsele în state
        setLoading(false); // Setează loading la false după ce datele sunt încărcate
      } catch (error) {
        console.error("Error fetching products: ", error);
      }
    };

    fetchProducts();
  }, [category]); // Reîncarcă produsele la schimbarea categoriei

  useEffect(() => {
    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];

    // Normalizează produsele pentru a avea câmpul `id`
    cart = cart.map((item) => {
      return item.productId ? { id: item.productId } : item; // Transformă `productId` în `id`
    });

    console.log("Cart normalized:", cart);
    setCart(cart); // Salvează coșul normalizat
  }, []);

  const handleAddToCart = (productId) => {
    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];

    // Verifică dacă produsul este deja în coș
    const isAlreadyInCart = cart.includes(productId);
    if (isAlreadyInCart) {
      toast.info("Produsul este deja în coș", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        closeButton: false,
      });
      return;
    }

    // Adaugă produsul în coș dacă nu există deja
    const newCart = [...cart, productId];
    console.log("Produs adăugat:", newCart);

    toast.success("Produs adăugat în coș", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      closeButton: false,
    });

    // Salvează coșul în sessionStorage și actualizează contextul
    sessionStorage.setItem("cart", JSON.stringify(newCart));
    updateCartCount(newCart); // Actualizează contextul cu noul coș
  };
  const handleProductClick = (productId) => {
    navigate(`/item/${productId}`); // Navighează la pagina produsului folosind ID-ul
  };

  if (loading) {
    return <p>Loading products...</p>;
  }

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent="center"
      alignItems="flex-start"
      margin={2}
    >
      {products.map((product) => (
        <Box
          key={product.id}
          m={1}
          width={{ xs: "100%", sm: "48%", md: "30%" }}
        >
          <div
            className="product-card"
            onClick={() => handleProductClick(product.id)} // Apelăm funcția de navigare cu ID-ul produsului
            style={{ cursor: "pointer" }}
          >
            <img
              src={product.imageURL[0]}
              alt={product.name}
              className="product-image"
            />
            <div className="product-info">
              <h3 className="product-name">{product.name}</h3>
              <div className="price-container">
                <p className="product-price">{product.price} RON</p>
                <button
                  onClick={(e) => {
                    e.stopPropagation(); // Previne declanșarea evenimentului de click pe card
                    handleAddToCart(product.id);
                  }}
                  className="add-to-cart"
                >
                  <FontAwesomeIcon icon={faShoppingCart} />
                  <span className="add-to-cart-text">Add to Cart</span>
                </button>
              </div>
            </div>
          </div>
        </Box>
      ))}
      <ToastContainer />
    </Box>
  );
};

export default ProductsCardContainer;
